import { Facebook, Language, LinkedIn, YouTube } from "@mui/icons-material";
import { IconButton, Paper } from "@mui/material";
import { Stack } from "@mui/system";
import React from "react";
import { tokens } from "../../../store/tokens";

// Per-network brand colors are intentional and kept as-is — that's the
// one place this component should NOT reach for the teal token, since
// each icon needs to stay recognizable as its own platform.
const NETWORKS = [
  { key: "facebook", Icon: Facebook, color: "#3B5998" },
  { key: "youtube", Icon: YouTube, color: "#D32F2F" },
  { key: "linkedin", Icon: LinkedIn, color: "#0072B1" },
  { key: "web", Icon: Language, color: tokens.color.teal },
];

const Accounts = (props) => {
  const { profileDetails } = props;
  const links = {
    facebook: profileDetails?.facebook,
    youtube: profileDetails?.youtube,
    linkedin: profileDetails?.linkedin,
    web: profileDetails?.web,
  };

  const handleGo = (value) => {
    if (value) window.open(value, "_blank", "noopener,noreferrer");
  };

  return (
    <Paper
      elevation={0}
      sx={{
        padding: `${tokens.card.padding.md}px`,
        borderRadius: `${tokens.card.radius}px`,
        border: `1px solid ${tokens.color.line}`,
        bgcolor: tokens.color.surface,
      }}
    >
      <Stack direction={"row"} spacing={1.5} justifyContent={"center"}>
        {NETWORKS.map(({ key, Icon, color }) => {
          const href = links[key];
          return (
            <IconButton
              key={key}
              onClick={() => handleGo(href)}
              disabled={!href}
              sx={{
                width: 40,
                height: 40,
                bgcolor: color,
                color: tokens.color.white,
                boxShadow: tokens.shadow.sm,
                "&:hover": { bgcolor: tokens.color.tealDark },
                "&.Mui-disabled": {
                  bgcolor: tokens.color.surfaceMuted,
                  color: tokens.color.inkFaint,
                },
              }}
            >
              <Icon fontSize="small" />
            </IconButton>
          );
        })}
      </Stack>
    </Paper>
  );
};

export default Accounts;
